import adPlacementService from "../../services/AdPlacementService";
import {useContext, useEffect, useRef, useState} from "react";
import Helpers from "../../helpers/Helpers";
import siteContext from "../../store/siteContext";
import c from "./AdvertPopupGeo.module.scss";
import SiteService from "../../services/SiteService";
import advertImage from "../../images/adv-1.webp";
import advertService from "../../services/AdvertService";
import UserContext from "../../store/userContext";

export default function AdvertPopupGeo({adPlacementId, name, limitCounties, hideFromPathnames,
	title, body, buttonText, delayUntilShow,
	background
}) { // popup ad
	if (hideFromPathnames && hideFromPathnames.includes(location.pathname.toLowerCase()))
		return null;

	const id = adPlacementId;

	const [ad, setAd] = useState(null);

	const [isHidden, setIsHidden] = useState(delayUntilShow?true:false);

	const adRef = useRef();
	const role = useContext(UserContext).role;
	let county = useContext(siteContext).geoLocationCounty;

	const isCorrectCounty = ()=>{
		if (!county) county = localStorage.getItem("geoLocationCounty");
		if (!limitCounties || !limitCounties.length) return true;
		return limitCounties.includes(county);
	}

	const [isVisible, setIsVisible] = useState(localStorage.getItem(name) == 'true'?false:true);

	useEffect(() => {
		if (delayUntilShow)
			setTimeout(() => {
				setIsHidden(false);
				handleGetAd();
			}, delayUntilShow||0);
	}, [county]);

	const handleGetAd = () => {
		if(!id || ad || !isCorrectCounty()) return;

		adPlacementService.getById(id, (ad)=>{
			ad.wideImage = Helpers.getRandomFromArray(ad.wideImages);
			setAd(ad);
		}, role > 0)
	};

	const closeBanner = () => {
		localStorage.setItem(name, 'true');
	};

	if (!isCorrectCounty()) return null;
	if (isHidden) return null;
	if (isVisible) return <a className={c.root} ref={adRef} target={"_blank"} href={ad&&ad.wideLink} style={background?{background:background}:null}>
		<div className={c.part1}  onClick={() => {
			if (role<1)advertService.advertOnclick(ad._id)
		}}>
			<div className={c.part1_1}>{title}</div>
			<div className={c.part1_2}>
				{body}
			</div>
			<div className={c.part1_3}>{buttonText?buttonText:'SE MER'}</div>
		</div>
		<div className={c.part2} onClick={() => {
			if (role<1)advertService.advertOnclick(ad._id)
		}}>
			{ad&&<img
				src={(ad && ad.wideImage) ? `${SiteService.apiPath}/image/adv/${ad._id}/${ad.wideImage}` : advertImage}/>}
		</div>

		<div className={c.annonse}>Annonse</div>
		<button onClick={(ev)=>{
			ev.preventDefault();
			setIsVisible(!isVisible);
			closeBanner();
		}}>
			{"Lukk ×"}
		</button>
	</a>

	else if (!isVisible) return <div className={c.mini} style={background?{background:background}:null}
		 onClick={(ev)=>{
			ev.preventDefault();
			setIsVisible(!isVisible);
			closeBanner();
	}}>
		<div className={c.plus} onClick={()=>{

		}}>+</div>
		<div className={c.miniText}>{title}</div>
		<div className={c.annonse}>Annonse</div>
	</div>
}